var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.field === "rowReorder"
    ? _c(
        "Draggable",
        {
          ref: "draggable",
          on: { press: _vm.onPress, drag: _vm.onDrag, release: _vm.onRelease }
        },
        [
          _c(
            "td",
            {
              class: _vm.tdClass,
              attrs: { "data-itemid": _vm.dataItem.Priority }
            },
            [
              _c(
                "span",
                { attrs: { "data-drag-handle": "true" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "material-icons",
                      staticStyle: { "pointer-events": "none" },
                      attrs: { id: "reordericon" }
                    },
                    [_vm._v("\n        drag_indicator\n      ")]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    : _c(
        "td",
        [
          _c(
            "v-icon",
            {
              staticClass: "material-icons",
              staticStyle: { "pointer-events": "none" },
              attrs: { id: "reordericon" }
            },
            [_vm._v("\n    block\n  ")]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }